export const ORDER_LIST_PAGE = 'ORDER_LIST_PAGE'
export const REMOVE_STYLE_COLORS_WITH_NO_QUANTITIES_PAGE =
  'REMOVE_STYLE_COLORS_WITH_NO_QUANTITIES_PAGE'
